// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"empty-state_Wrapper__DPnEv"};